import { RequestLog } from '@engine/models'

import { ActivityTimeline } from '#components/ActivityTimeline'
import { EmptyState } from '#components/EmptyState'
import { ErrorsSection } from '#components/ErrorsSection'
import { KeyValueDisplay } from '#components/KeyValueDisplay'
import { RequestLogSections } from '#components/RequestLogSections'
import { formatDateTime } from '#utils/format'

import { GetTrackingStatusBadge } from './GetTrackingStatusBadge'

interface GetTrackingDetailsProps {
  tracking: RequestLog | null
}

const GetTrackingDetails = ({ tracking }: GetTrackingDetailsProps) => {
  if (!tracking) {
    return <EmptyState title="Select a tracking lookup to view details" />
  }

  const responseContent = tracking.tenantResponse?.content as any
  const errorType = responseContent?.errorType
  const errors = responseContent?.errors
  const externalId =
    tracking.externalId || tracking.tenantRequest?.content?.trackingNumber

  return (
    <div className="space-y-6">
      {/* Overview Section */}
      <KeyValueDisplay
        items={[
          { label: 'External ID', value: tracking.externalId },
          { label: 'Request ID', value: tracking.requestId },
          { label: 'Tenant ID', value: tracking.tenantId },
          { label: 'Type', value: tracking.type },
          {
            label: 'Carrier',
            value:
              tracking.carrierCode && tracking.carrierCode.length > 0
                ? tracking.carrierCode.join(', ')
                : 'N/A',
          },
          {
            label: 'Request Date',
            value: formatDateTime(tracking.tenantRequest?.requestDate),
          },
          {
            label: 'Status',
            value: <GetTrackingStatusBadge log={tracking} />,
          },
          ...(errorType ? [{ label: 'Error Type', value: errorType }] : []),
        ]}
      />

      {/* Errors Section */}
      <ErrorsSection
        errors={errors}
        errorType={errorType}
        carrier={tracking.carrierCode?.[0]}
        requestId={tracking.requestId}
        externalId={externalId}
        service="tracking"
      />

      <RequestLogSections requestLog={tracking} />

      <ActivityTimeline
        externalId={externalId}
        requestLogType="track"
        emptyMessage="No traces or request logs found for this tracking."
      />
    </div>
  )
}

export { GetTrackingDetails }
